import { FC } from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { addHelperText, contactCopy, type ContactType } from './contactInfo';

interface AddContactDialogProps {
  type: ContactType;
  open: boolean;
  value: string;
  saving: boolean;
  error: string | null;
  /** First name of the contact owner when editing another person's contacts. */
  ownerName?: string;
  onClose: () => void;
  onValueChange: (value: string) => void;
  onSubmit: () => void;
}

const AddContactDialog: FC<AddContactDialogProps> = ({
  type,
  open,
  value,
  saving,
  error,
  ownerName,
  onClose,
  onValueChange,
  onSubmit,
}) => {
  const copy = contactCopy[type];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{copy.addTitle}</DialogTitle>
      <DialogContent>
        <Stack gap={2} sx={{ pt: 1 }}>
          {error && (
            <Alert severity="error" sx={{ py: 0 }}>
              {error}
            </Alert>
          )}
          <TextField
            label={copy.addLabel}
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            type={type === 'phone' ? 'tel' : 'email'}
            size="small"
            fullWidth
            autoFocus
            placeholder={type === 'phone' ? '(555) 123-4567' : undefined}
            inputProps={type === 'phone' ? { maxLength: 14 } : undefined}
          />
          <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
            {addHelperText(type, ownerName)}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={saving || !value.trim()}
          startIcon={saving ? <CircularProgress size={14} /> : null}
        >
          <span>{saving ? 'Sending…' : 'Send Verification'}</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddContactDialog;
